module.exports = __webpack_public_path__ + "img/22.d2f6251c.png";